import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/funcion/importer/funcionImporterActions';

export default importerReducers(actions);
